import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getStationNameForCode } from "../../../shared/utils/mapUtils";
import { CloseBtn, StFrom, StTo, ViewSt } from "../../common/svg/AllSvg";

const Popup = ({ isPopupOpen, stationName, handleButtonClick, setIsPopupOpen }: any) => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const params = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation('common');

    const handleNavigate = () => {
        !!params?.lang ? navigate(`/${params?.lang}/station/${stationName}`) : navigate(`/station/${stationName}`)
    }

    return (
        <div id='popup' className={`w-[280px] rounded-[8px] backdrop-blur-[1.14] bg-white dark:bg-bgDarkDull p-[15px] ${isPopupOpen ? "block" : "hidden"}`}>
            <div className="flex w-full justify-between">
                <h4 className="text-primary font-bold">{getStationNameForCode(stationName, lang)}</h4>

                <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="mt-[-3px] mr-[-3px] h-fit rounded-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] flex items-center justify-center bg-[#e4e4e4] dark:bg-[#4c4e5e5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setIsPopupOpen(false)}>
                    <CloseBtn className="w-[19px] h-[19px]" />
                </button>
            </div>

            <div className="flex items-center gap-[10px] mt-[15px]">
                <button className="border border-[#E6E6E6] dark:border-[#535353] dark:bg-[#0C0C0C] bg-[#fbfbfb] rounded-[6px] h-[30px] px-[12px] flex items-center gap-[8px] w-full justify-center text-blackDull dark:text-textBlackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e]" onClick={() => handleButtonClick('from')}><StFrom /> <p className="font-semibold" >{t("passenger.map.st_from")}</p></button>
                <button className="border border-[#E6E6E6] dark:border-[#535353] dark:bg-[#0C0C0C] bg-[#fbfbfb] rounded-[6px] h-[30px] px-[12px] flex items-center gap-[8px] w-full justify-center text-blackDull dark:text-textBlackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e]" onClick={() => handleButtonClick('to')}><StTo /> <p className="font-semibold">{t("passenger.map.st_to")}</p></button>
            </div>

            <button className="border border-[#E6E6E6] dark:border-[#535353] dark:bg-[#0C0C0C] bg-[#fbfbfb] rounded-[6px] h-[30px] px-[12px] flex items-center justify-center gap-[8px] text-blackDull dark:text-textBlackDull mt-[10px] w-full focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e]"><ViewSt /> <p className="font-semibold" onClick={handleNavigate}>{t("passenger.map.view_st")}</p></button>
        </div>
    );
};

export default Popup;